import React from 'react';

const FilterBar = ({ query, count = 0, currentChosenRecommendation, isHidingReviewed = false }) => {
  const isPartialResult = query.ft.length > 0 || query.orderby !== "count" ;

  return (
    <div className='mb-8'>
      <p className='font-medium'>
        {currentChosenRecommendation 
          ? `目前顯示的是【${currentChosenRecommendation}】` 
          : `找到${isPartialResult ? "最符合條件的" : ""} ${count} 款${isHidingReviewed ? "，以下只顯示尚未遊玩（評價／紀錄）的" : ""}遊戲${count > 50 ? "，建議增加條件限縮搜尋範圍喔！" : "："}`
        }
      </p>
    </div>
  );
}

export default FilterBar;